// ----------------------------------------------------------------------------- //
// 	Set dropdown state
// ----------------------------------------------------------------------------- //
export default function setDropdownState( ref = document ) {

	const dropdown = ref.querySelectorAll('.js-dropdown');

	const isExpanded = ( elem ) => {
		elem.setAttribute("aria-expanded", "true");
		elem.nextElementSibling.setAttribute("aria-hidden", "false");
		elem.closest('li').classList.add('is-expanded');
	}

	const isCollapsed = ( elem ) => {
		elem.setAttribute("aria-expanded", "false");
		elem.nextElementSibling.setAttribute("aria-hidden", "true");
		elem.closest('li').classList.remove('is-expanded');
	}

	if ( dropdown.length ) {
		dropdown.forEach((e) => {

			const dropdownToggle = e.querySelectorAll('.js-dropdown-toggle');

			dropdownToggle.forEach((btn) => {

				// Set state
				btn.addEventListener("click", () => {

					// Check if submenu is already expanded
					if ( btn.getAttribute("aria-expanded") == "false" ) {
						isExpanded( btn );
					} else {
						isCollapsed( btn );
					}
				});

				if ( e.getAttribute("data-autoclose") == "outside" ) {

					// Close submenu when clicking outside of it
					ref.addEventListener("click", (event) => {			
						if ( ! btn.contains(event.target) && ! btn.nextElementSibling.contains(event.target) ) {
							isCollapsed( btn );
						}
					});
				}
			});
		});
	}
};
